import * as S from './index.style'
import React, { useState } from 'react'
import { DadosDatas, ValidacaoDadosDatas } from 'models/Viabilidade/Datas'
import { KeyboardDatePicker } from '@material-ui/pickers/DatePicker'
import { parseISO, isValid } from 'date-fns'
import { Event } from '@styled-icons/material-rounded'
import theme from 'styles/theme'

const Datas: React.FC<{ dadosDatas: DadosDatas; dadosDatasHandler: (novoValor: DadosDatas) => void }> = ({ dadosDatas, dadosDatasHandler }) => {
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosDatas())
  const [valores, setValores] = useState(dadosDatas)
  const ValorArialLabel = 'change date'
  const minDate = parseISO('1900-01-01 00:00:00')

  const compraHandler = (date: Date | null) => {
    const state = { ...valores } as DadosDatas
    state.compra = date as Date

    setValores(state)
    dadosDatasHandler(state)

    if (isValid(date)) validarCompra(date)
  }

  const alvaraAprovacaoHandler = (date: Date | null) => {
    const state = { ...valores } as DadosDatas
    state.alvaraAprovacao = date as Date

    setValores(state)
    dadosDatasHandler(state)

    if (isValid(date)) validarAlvaraAprovacao(date)
  }

  const alvaraExecucaoHandler = (date: Date | null) => {
    const state = { ...valores } as DadosDatas
    state.alvaraExecucao = date as Date

    setValores(state)
    dadosDatasHandler(state)

    if (isValid(date)) validarAlvaraExecucao(date)
  }

  const registroEscrituraHandler = (date: Date | null) => {
    const state = { ...valores } as DadosDatas
    state.registroEscritura = date as Date

    setValores(state)
    dadosDatasHandler(state)

    if (isValid(date)) validarRegistroEscritura(date)
  }

  const previsaoRiHandler = (date: Date | null) => {
    const state = { ...valores } as DadosDatas
    state.previsaoRi = date as Date

    setValores(state)
    dadosDatasHandler(state)

    if (isValid(date)) validarPrevisaoRi(date)
  }

  const previsaoLancamentoHandler = (date: Date | null) => {
    const state = { ...valores } as DadosDatas
    state.previsaoLancamento = date as Date

    setValores(state)
    dadosDatasHandler(state)

    if (isValid(date)) validarPrevisaoLancamento(date)
  }

  const validarCompraHandler = () => {
    validarCompra(null)
  }

  const validarAlvaraAprovacaoHandler = () => {
    validarAlvaraAprovacao(null)
  }

  const validarAlvaraExecucaoHandler = () => {
    validarAlvaraExecucao(null)
  }

  const validarRegistroEscrituraHandler = () => {
    validarRegistroEscritura(null)
  }

  const validarPrevisaoRiHandler = () => {
    validarPrevisaoRi(null)
  }

  const validarPrevisaoLancamentoHandler = () => {
    validarPrevisaoLancamento(null)
  }

  const converterDadosDatasParaListaDatas = (dadosDatas: DadosDatas): Date[] => {
    return [
      dadosDatas.alvaraAprovacao,
      dadosDatas.alvaraExecucao,
      dadosDatas.compra,
      dadosDatas.previsaoRi,
      dadosDatas.registroEscritura,
      dadosDatas.previsaoLancamento
    ]
  }

  const validarCompra = (data: Date | null) => {
    const dataCompra = data ?? valores.compra
    const erroCompra = mensagensErro.validarInputUsuario(dataCompra)

    const validador = new ValidacaoDadosDatas(
      erroCompra,
      mensagensErro.alvaraAprovacao,
      mensagensErro.alvaraExecucao,
      mensagensErro.registroEscritura,
      mensagensErro.previsaoRi,
      mensagensErro.previsaoLancamento
    )

    valores.compra = dataCompra
    const listaDatas = converterDadosDatasParaListaDatas(valores)

    if (listaDatas.every((element) => element != null && isValid(element))) {
      validador.compra = mensagensErro.validarDataCompra(valores)
      validador.previsaoLancamento = mensagensErro.validarPrevisaoLancamento(valores)
    }

    validarCard(validador)
    setMensagensErro(validador)
  }

  const validarAlvaraAprovacao = (data: Date | null) => {
    const dataAlvaraAprovacao = data ?? valores.alvaraAprovacao
    const erroAlvaraAprovacao = mensagensErro.validarInputUsuario(dataAlvaraAprovacao)

    const validador = new ValidacaoDadosDatas(
      mensagensErro.compra,
      erroAlvaraAprovacao,
      mensagensErro.alvaraExecucao,
      mensagensErro.registroEscritura,
      mensagensErro.previsaoRi,
      mensagensErro.previsaoLancamento
    )

    valores.alvaraAprovacao = dataAlvaraAprovacao
    const listaDatas = converterDadosDatasParaListaDatas(valores)

    if (listaDatas.every((element) => element != null && isValid(element))) {
      validador.compra = mensagensErro.validarDataCompra(valores)
      validador.previsaoLancamento = mensagensErro.validarPrevisaoLancamento(valores)
    }

    validarCard(validador)
    setMensagensErro(validador)
  }

  const validarAlvaraExecucao = (data: Date | null) => {
    const dataAlvaraExecucao = data ?? valores.alvaraExecucao
    const erroAlvaraExecucao = mensagensErro.validarInputUsuario(dataAlvaraExecucao)

    const validador = new ValidacaoDadosDatas(
      mensagensErro.compra,
      mensagensErro.alvaraAprovacao,
      erroAlvaraExecucao,
      mensagensErro.registroEscritura,
      mensagensErro.previsaoRi,
      mensagensErro.previsaoLancamento
    )

    valores.alvaraExecucao = dataAlvaraExecucao
    const listaDatas = converterDadosDatasParaListaDatas(valores)

    if (listaDatas.every((element) => element != null && isValid(element))) {
      validador.compra = mensagensErro.validarDataCompra(valores)
      validador.previsaoLancamento = mensagensErro.validarPrevisaoLancamento(valores)
    }

    validarCard(validador)
    setMensagensErro(validador)
  }

  const validarRegistroEscritura = (data: Date | null) => {
    const dataRegistroEscritura = data ?? valores.registroEscritura
    const erroRegistroEscritura = mensagensErro.validarInputUsuario(dataRegistroEscritura)

    const validador = new ValidacaoDadosDatas(
      mensagensErro.compra,
      mensagensErro.alvaraAprovacao,
      mensagensErro.alvaraExecucao,
      erroRegistroEscritura,
      mensagensErro.previsaoRi,
      mensagensErro.previsaoLancamento
    )

    valores.registroEscritura = dataRegistroEscritura
    const listaDatas = converterDadosDatasParaListaDatas(valores)

    if (listaDatas.every((element) => element != null && isValid(element))) {
      validador.compra = mensagensErro.validarDataCompra(valores)
      validador.previsaoLancamento = mensagensErro.validarPrevisaoLancamento(valores)
    }

    validarCard(validador)
    setMensagensErro(validador)
  }

  const validarPrevisaoRi = (data: Date | null) => {
    const dataPrevisaoRi = data ?? valores.previsaoRi
    const erroPrevisaoRi = mensagensErro.validarInputUsuario(dataPrevisaoRi)

    const validador = new ValidacaoDadosDatas(
      mensagensErro.compra,
      mensagensErro.alvaraAprovacao,
      mensagensErro.alvaraExecucao,
      mensagensErro.registroEscritura,
      erroPrevisaoRi,
      mensagensErro.previsaoLancamento
    )

    valores.previsaoRi = dataPrevisaoRi
    const listaDatas = converterDadosDatasParaListaDatas(valores)

    if (listaDatas.every((element) => element != null && isValid(element))) {
      validador.compra = mensagensErro.validarDataCompra(valores)
      validador.previsaoLancamento = mensagensErro.validarPrevisaoLancamento(valores)
    }

    validarCard(validador)
    setMensagensErro(validador)
  }

  const validarPrevisaoLancamento = (data: Date | null) => {
    const dataPrevisaoLancamento = data ?? valores.previsaoLancamento
    const erroPrevisaoLancamento = mensagensErro.validarInputUsuario(dataPrevisaoLancamento)

    const validador = new ValidacaoDadosDatas(
      mensagensErro.compra,
      mensagensErro.alvaraAprovacao,
      mensagensErro.alvaraExecucao,
      mensagensErro.registroEscritura,
      mensagensErro.previsaoRi,
      erroPrevisaoLancamento
    )

    valores.previsaoLancamento = dataPrevisaoLancamento
    const listaDatas = converterDadosDatasParaListaDatas(valores)

    if (listaDatas.every((element) => element != null && isValid(element))) {
      validador.compra = mensagensErro.validarDataCompra(valores)
      validador.previsaoLancamento = mensagensErro.validarPrevisaoLancamento(valores)
    }

    validarCard(validador)
    setMensagensErro(validador)
  }

  const validarCard = (validador: ValidacaoDadosDatas) => {
    const state = { ...valores } as DadosDatas
    state.valido = validador.validarTodosCampos(state)

    setValores(state)
    dadosDatasHandler(state)
  }

  return (
    <S.Wrapper data-cy="sessaoDatas">
      <S.NomeSecao>Datas</S.NomeSecao>
      <S.GridCustomizado orientacao="column" gridTemplateColumns="repeat(3,184px)" gridTemplateRow="repeat(2,1fr)" gridGap="32px" margin="0 0 48px 0">
        <div>
          <S.Label>Compra</S.Label>
          <KeyboardDatePicker
            placeholder="DD / MM / AAAA"
            inputVariant="outlined"
            margin="none"
            name="compra"
            data-cy="campoCompra"
            value={valores.compra}
            onBlur={validarCompraHandler}
            format="dd/MM/yyyy"
            onChange={compraHandler}
            minDate={minDate}
            openTo="date"
            views={['year', 'month', 'date']}
            KeyboardButtonProps={{
              'aria-label': ValorArialLabel
            }}
            size="small"
            error={mensagensErro.compra != ''}
            helperText={mensagensErro.compra}
            keyboardIcon={<Event size={24} color={theme.colors.gray4} />}
          />
        </div>
        <div>
          <S.Label>Alvará de Aprovação</S.Label>
          <KeyboardDatePicker
            placeholder="DD / MM / AAAA"
            inputVariant="outlined"
            margin="none"
            name="alvaraAprovacao"
            data-cy="campoAlvaraAprovacao"
            format="dd/MM/yyyy"
            value={valores.alvaraAprovacao}
            onChange={alvaraAprovacaoHandler}
            onBlur={validarAlvaraAprovacaoHandler}
            minDate={minDate}
            openTo="date"
            views={['year', 'month', 'date']}
            KeyboardButtonProps={{
              'aria-label': ValorArialLabel
            }}
            size="small"
            error={mensagensErro.alvaraAprovacao != ''}
            helperText={mensagensErro.alvaraAprovacao}
            keyboardIcon={<Event size={24} color={theme.colors.gray4} />}
          />
        </div>
        <div>
          <S.Label>Alvará de Execução</S.Label>
          <KeyboardDatePicker
            placeholder="DD / MM / AAAA"
            inputVariant="outlined"
            margin="none"
            name="alvaraExecucao"
            data-cy="campoAlvaraExecucao"
            format="dd/MM/yyyy"
            value={valores.alvaraExecucao}
            onChange={alvaraExecucaoHandler}
            onBlur={validarAlvaraExecucaoHandler}
            minDate={minDate}
            openTo="date"
            views={['year', 'month', 'date']}
            KeyboardButtonProps={{
              'aria-label': 'change date'
            }}
            size="small"
            error={mensagensErro.alvaraExecucao != ''}
            helperText={mensagensErro.alvaraExecucao}
            keyboardIcon={<Event size={24} color={theme.colors.gray4} />}
          />
        </div>
        <div>
          <S.Label>Registro da Escritura</S.Label>
          <KeyboardDatePicker
            placeholder="DD / MM / AAAA"
            inputVariant="outlined"
            margin="none"
            name="registroEscritura"
            data-cy="campoRegistroEscritura"
            value={valores.registroEscritura}
            format="dd/MM/yyyy"
            onChange={registroEscrituraHandler}
            onBlur={validarRegistroEscrituraHandler}
            openTo="date"
            views={['year', 'month', 'date']}
            KeyboardButtonProps={{
              'aria-label': ValorArialLabel
            }}
            size="small"
            error={mensagensErro.registroEscritura != ''}
            helperText={mensagensErro.registroEscritura}
            keyboardIcon={<Event size={24} color={theme.colors.gray4} />}
          />
        </div>
        <div>
          <S.Label>Previsão do RI</S.Label>
          <KeyboardDatePicker
            placeholder="DD / MM / AAAA"
            inputVariant="outlined"
            margin="none"
            name="previsaoRi"
            data-cy="campoPrevisaoRi"
            format="dd/MM/yyyy"
            value={valores.previsaoRi}
            onChange={previsaoRiHandler}
            onBlur={validarPrevisaoRiHandler}
            minDate={minDate}
            openTo="date"
            views={['year', 'month', 'date']}
            KeyboardButtonProps={{
              'aria-label': ValorArialLabel
            }}
            size="small"
            error={mensagensErro.previsaoRi != ''}
            helperText={mensagensErro.previsaoRi}
            keyboardIcon={<Event size={24} color={theme.colors.gray4} />}
          />
        </div>
        <div>
          <S.Label>Previsão de Lançamento</S.Label>
          <KeyboardDatePicker
            placeholder="DD / MM / AAAA"
            inputVariant="outlined"
            margin="none"
            name="previsaoLancamento"
            data-cy="campoPrevisaoLancamento"
            format="dd/MM/yyyy"
            value={valores.previsaoLancamento}
            onChange={previsaoLancamentoHandler}
            onBlur={validarPrevisaoLancamentoHandler}
            minDate={minDate}
            openTo="date"
            views={['year', 'month', 'date']}
            KeyboardButtonProps={{
              'aria-label': ValorArialLabel
            }}
            size="small"
            error={mensagensErro.previsaoLancamento != ''}
            helperText={mensagensErro.previsaoLancamento}
            keyboardIcon={<Event size={24} color={theme.colors.gray4} />}
          />
        </div>
      </S.GridCustomizado>
    </S.Wrapper>
  )
}

export default Datas
